export const OPEN_VERSION_CELL_DIFF_EVENT = "smart-table:open-version-cell-diff";

export interface VersionCellDiffDialogDetail {
  rowIndex: number;
  columnId: string;
  beforeValue: string;
  afterValue: string;
  beforePreview: string;
  afterPreview: string;
}

interface VersionInlineCellDiffViewerProps {
  oldValue: string;
  newValue: string;
}

const INLINE_DIFF_CONTEXT_CHARS = 42;

const normalizeInlineDiffValue = (value: string): string => value.replace(/\s+/g, " ").trim();

const getSharedPrefixLength = (left: string, right: string): number => {
  let index = 0;

  while (index < left.length && index < right.length && left[index] === right[index]) {
    index += 1;
  }

  return index;
};

const getSharedSuffixLength = (left: string, right: string, prefixLength: number): number => {
  let length = 0;

  while (
    length < left.length - prefixLength &&
    length < right.length - prefixLength &&
    left[left.length - 1 - length] === right[right.length - 1 - length]
  ) {
    length += 1;
  }

  return length;
};

const getCompactPrefix = (value: string): string =>
  value.length > INLINE_DIFF_CONTEXT_CHARS
    ? `…${value.slice(value.length - INLINE_DIFF_CONTEXT_CHARS)}`
    : value;

const getCompactSuffix = (value: string): string =>
  value.length > INLINE_DIFF_CONTEXT_CHARS
    ? `${value.slice(0, INLINE_DIFF_CONTEXT_CHARS)}…`
    : value;

export const VersionInlineCellDiffViewer = ({
  oldValue,
  newValue,
}: VersionInlineCellDiffViewerProps) => {
  const oldText = normalizeInlineDiffValue(oldValue);
  const newText = normalizeInlineDiffValue(newValue);
  const prefixLength = getSharedPrefixLength(oldText, newText);
  const suffixLength = getSharedSuffixLength(oldText, newText, prefixLength);

  const prefix = getCompactPrefix(newText.slice(0, prefixLength));
  const suffix = getCompactSuffix(
    suffixLength > 0 ? newText.slice(newText.length - suffixLength) : "",
  );
  const removed = oldText.slice(prefixLength, oldText.length - suffixLength);
  const added = newText.slice(prefixLength, newText.length - suffixLength);

  return (
    <div className="flex h-full min-w-0 items-center overflow-hidden whitespace-nowrap text-sm text-slate-600">
      <span className="min-w-0 overflow-hidden text-ellipsis">
        {prefix}
        {removed && (
          <span className="rounded-[3px] bg-rose-100 px-0.5 text-rose-700 line-through decoration-rose-500/70">
            {removed}
          </span>
        )}
        {added && (
          <span className="rounded-[3px] bg-emerald-100 px-0.5 text-emerald-700">{added}</span>
        )}
        {suffix}
      </span>
    </div>
  );
};
